import React, { Component,  } from 'react';
import '../../components/course/styling/MyPatSlider.css'


interface MyPatSliderProgressProps {
    percentage:number
}


interface MyPatSliderProgressState {
}


class MyPatSliderProgress extends Component<MyPatSliderProgressProps, MyPatSliderProgressState>{

    constructor(props: MyPatSliderProgressProps, state: MyPatSliderProgressState) {
        super(props);
    }

    render() {
        const{percentage} = this.props;
        return (
            <div className={`slider`}>
                <input type="range" style={{background: `linear-gradient(to right, #6BCB3E 0%, #6BCB3E ${percentage.toString()}%, #dfdfdf ${percentage.toString()}%, #dfdfdf 100%)`}} value={percentage} className={'rangeInput'} />
            </div>
        )
    }
}


// @ts-ignore
export default (MyPatSliderProgress);

